import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import './Shimmer.css';

export const Placeholder = ({ style }) => (
  <div style={style} className="placeholder" />
);

function getUnit(value) {
  if (typeof value === 'number') {
    return 'px';
  }

  return '';
}

export const Spacer = ({ size, horizontal }) => {
  const spacerStyles = {
    minHeight: !horizontal && size,
    minWidth: horizontal && size,
    flex: `0 0 ${size}${getUnit(size)}`,
  };

  return <div style={spacerStyles} />;
};

export const TextBoxPlaceholder = () => (
  <Fragment>
    <Spacer size={20} />
    <Placeholder
      style={{
        width: 300,
        height: 20,
      }}
    />
    <Spacer size={10} />
    <Placeholder
      style={{
        width: 250,
        height: 15,
      }}
    />
    <Spacer size={10} />

    <Placeholder
      style={{
        width: 220,
        height: 10,
      }}
    />
  </Fragment>
);

Placeholder.propTypes = {
  style: PropTypes.object,
};
Spacer.propTypes = {
  size: PropTypes.number,
  horizontal: PropTypes.bool,
};

Placeholder.defaultProps = {
  style: {},
};
Spacer.defaultProps = {
  size: 0,
  horizontal: false,
};



// WEBPACK FOOTER //
// ./src/components/Shimmer/index.js